import { eventHub } from '@/services/eventhub';

export const baseMixin = {
	created: function() {},
	
	computed: {
		isDetailPage: function() {
			if (!this.routeShowing || this.routeShowing === null) {
				return false;
			}

			return this.routeShowing !== null;
		},
		currentPackageIsDetail: function() {
			if (this.routeShowing && this.resultItem) {
				return (
					this.routeShowing &&
					this.routeShowing.packageId === this.resultItem.SerialId
				);
			} else {
				return false;
			}
		}
	},
	data() {
		return {
			routeShowing: null,
			lastDetailRoute: null,
			showingForm: false
		};
	},
	mounted() {
		eventHub.$on('changed-detail', params => {
			this.routeShowing = params;
		});
		eventHub.$on('show-overview', () => {
			this.routeShowing = null;
		});
		eventHub.$on('show-overview', () => {
			this.routeShowing = null;
		});
		eventHub.$on('show-form', ()=> {
			this.showingForm = true;
		});
		eventHub.$on('hide-form', () => {
			this.showingForm = false;
		});
	},
	methods: {
		getUrlParams() {
			let query = window.location.search.substring(1);
			let vars = query.split('&');

			let params = [];

			for (var i = 0; i < vars.length; i++) {
				if(vars[i] !== "") {
					let pair = vars[i].split('=');
						params.push({
								key: pair[0],
								value: decodeURIComponent(pair[1])
						});
				}
			}
			return params;
		},
		showAsRoute: function(settings) {
			if (!settings && this.routeShowing) {
				this.lastDetailRoute = this.routeShowing;
			}

			this.routeShowing = settings;
			let routeSettings = {
				packageId: settings && settings.packageId ? settings.packageId : null,
				view: 'detail'
			};
			try {
				history.pushState(routeSettings, 'Detailpagina');
			} catch (e) {
				console.info("Couldnt push state to history");
			}
			eventHub.$emit('changed-detail', routeSettings);
		},
		showForm: function(resultItem, origin = '(unknown)') {
			try {
				history.pushState(
					{ view: 'form', ...resultItem },
					'Registratieformulier'
				);
			} catch (e) { 
				console.info("Couldnt push state to history");
			}			
			eventHub.$emit('show-form', resultItem);
			this.track(
				`Show Registration Form from ${origin}`,
				resultItem.SupplierUrlName,
				resultItem.UrlName
			);
		},
		emit(event, data) {
			eventHub.$emit(event, data);
		},
		getSerialIdFromUrl: function(options = {}) {
			if (options.fromOldRoute) {
				return this.lastDetailRoute ? this.lastDetailRoute.packageId : null;
			} else {
				return this.routeShowing ? this.routeShowing.packageId : null;
			}
		},
		setLs: function(key, value) {
			localStorage.setItem(key, value);
		},
		getLs: function(key) {
			let lsItem = localStorage.getItem(key);
			return lsItem ? lsItem : null;
		},
		storageGetValue: function(key) {
			let userData = this.getStorageObject();
			return userData ? userData[key] : null;
		},
		storageSetValue: function(key, value) {
			let userData = this.getStorageObject();
			if (!userData) {
				userData = {};
			}
			userData[key] = value;
			this.setStorageObject(userData);
		},

		goToUrl(url) {
			// eslint-disable-next-line
			if (APP_TYPE === 'app') {
				if (window.top) {
					window.top.location.href = url;
				} else {
					window.location.href = url;
				}
			} else {
				window.location.href = url;
			}
		},
		storageSetObject: function(userData, key = 'userData') {
			localStorage.setItem(key, JSON.stringify(userData));
		},
		storageGetObject: function(key = 'userData') {
			if (localStorage.getItem(key)) {
				return JSON.parse(localStorage.getItem(key));
			} else {
				return null;
			}
		},
		storageRemoveObject: function(key) {
			if (!key) {
				console.error('Key needed for removal');
				return;
			}
			localStorage.removeItem(key);
		},
		track: function(cat = 'WLB', action = 'Tonen', label = 'Detail') {
			let trackingObject = {
				hitType: 'event',
				eventCategory: `WLB: ${cat}`,
				eventAction: action,
				eventLabel: label,
				eventValue: 0
			};
			if (this.$ga) {
				// eslint-disable-next-line
				this.$ga.event(trackingObject);
			} // eslint-disable-next-line
			else if (window.ga && typeof window.ga === 'function') {
				// eslint-disable-next-line
				window.ga('send', trackingObject);
			} else {
				//console.log('Both trackers not found');
			}
		}
	}
};
